import React from 'react'

function CryPayGatDev() {
  return (
    <>
      <div
        className="about-style-three-area default-padding bg-gray bg-cover"
        style={{ background: "url(assets/img/shape/banner-16.html)" }}
      >
        <div className="container">
          <div className="row">
            <div className="col-lg-6">
              <h4 className="sub-title">AI writing assistant</h4>
              <h2 className="title split-text-right split-text-in-right">
                Crypto Payment Gateway Development by Xeer Technology
              </h2>
              <p>
                At Xeer Technology, we specialize in developing robust and
                efficient Crypto Payment Gateways that empower businesses to
                embrace the future of finance. Our solutions are designed to
                facilitate seamless cryptocurrency transactions, providing a
                secure and user-friendly experience for both merchants and
                customers.
              </p>
              {/* <p>
                Our development process ensures that your wallet clone app is
                tailored to meet your specific requirements, offering additional
                functionality like multi-signature authentication, in-app token
                swaps, and integrated staking or yield farming features.
              </p> */}
              <a className="btn btn-style-one" href="#">
                Know more
              </a>
            </div>
            <div className="col-lg-6">
              <div className="about-style-three-thumb">
                <img
                  className="fade-up-anim"
                  src="https://validthemes.net/site-template/robok/assets/img/illustration/dashboard-4.jpg"
                  alt="Image Not Found"
                />
                <img
                  className="fade-up-anim"
                  src="https://validthemes.net/site-template/robok/assets/img/illustration/1.gif"
                  alt="Image Not Found"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default CryPayGatDev
